/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_MemoryInputs */

const en_svtag_memory = /** @type {(inputs: Svtag_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MEMORY`)
};

const ar_svtag_memory = /** @type {(inputs: Svtag_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ذاكرة`)
};

const bn_svtag_memory = /** @type {(inputs: Svtag_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MEMORY`)
};

const de_svtag_memory = /** @type {(inputs: Svtag_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MEMORY`)
};

const es_svtag_memory = /** @type {(inputs: Svtag_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MEMORY`)
};

const fr_svtag_memory = /** @type {(inputs: Svtag_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MEMORY`)
};

const pt_svtag_memory = /** @type {(inputs: Svtag_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MEMORY`)
};

const zh_svtag_memory = /** @type {(inputs: Svtag_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MEMORY`)
};

const tr_svtag_memory = /** @type {(inputs: Svtag_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MEMORY`)
};

const ru_svtag_memory = /** @type {(inputs: Svtag_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MEMORY`)
};

const pl_svtag_memory = /** @type {(inputs: Svtag_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MEMORY`)
};

/**
* | output |
* | --- |
* | "#MEMORY" |
*
* @param {Svtag_MemoryInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_memory = /** @type {((inputs?: Svtag_MemoryInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_MemoryInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_memory(inputs)
	if (locale === "bn") return bn_svtag_memory(inputs)
	if (locale === "de") return de_svtag_memory(inputs)
	if (locale === "es") return es_svtag_memory(inputs)
	if (locale === "fr") return fr_svtag_memory(inputs)
	if (locale === "pt") return pt_svtag_memory(inputs)
	if (locale === "zh") return zh_svtag_memory(inputs)
	if (locale === "tr") return tr_svtag_memory(inputs)
	if (locale === "ru") return ru_svtag_memory(inputs)
	if (locale === "pl") return pl_svtag_memory(inputs)
	return en_svtag_memory(inputs)
});